module.exports = __webpack_public_path__ + "img/86.10.pH.1fa96d48.png";